import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const session_id = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending", lookup_key: null });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!session_id) return;
    let stopped = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        setStatus(data);
        if (data.payment_status === "paid" || data.payment_status === "expired" || data.payment_status === "failed" || tries > 20) {
          return;
        }
      } catch {}
      if (!stopped) {
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { stopped = true; };
    // eslint-disable-next-line
  }, [session_id, tries]);

  const paid = status.payment_status === "paid";

  return (
    <div className="bg-[#F8FAFC] min-h-screen flex items-center justify-center px-5">
      <div className="max-w-lg w-full bg-white border border-[#E2E8F0] p-10 text-center" data-testid="payment-success-page">
        {paid ? (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[#2D5A3F] mb-4" />
            <p className="eyebrow">Pago confirmado</p>
            <h1 className="font-serif text-3xl font-semibold text-[#1A1A1A] mt-1">
              ¡Todo listo! Gracias.
            </h1>
            <p className="mt-3 text-[#475569]">
              {status.lookup_key?.startsWith("premium") ? (
                <>Tu membresía Premium ya está activa. Disfruta de anticipación y sin banners.</>
              ) : status.lookup_key?.startsWith("banner") ? (
                <>Tu banner está activo. Aparecerá en portada y páginas de listado durante el periodo contratado.</>
              ) : (
                <>Gracias por tu pago.</>
              )}
            </p>
            <div className="mt-6 flex justify-center gap-2">
              <Button onClick={() => navigate("/")} className="rounded-none h-11 bg-[#1A1A1A] hover:bg-[#2A2A2A] text-[#F8FAFC] px-6">
                Volver a la portada
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="w-14 h-14 mx-auto border-4 border-[#3B5FB8] border-t-transparent rounded-full animate-spin mb-4" />
            <p className="eyebrow">Procesando</p>
            <h1 className="font-serif text-3xl font-semibold text-[#1A1A1A] mt-1">Confirmando tu pago…</h1>
            <p className="mt-3 text-sm text-[#475569]">Un momento. Estamos verificando la transacción con Stripe.</p>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancelledPage() {
  const navigate = useNavigate();
  return (
    <div className="bg-[#F8FAFC] min-h-screen flex items-center justify-center px-5">
      <div className="max-w-lg w-full bg-white border border-[#E2E8F0] p-10 text-center" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 mx-auto text-[#64748B] mb-4" />
        <h1 className="font-serif text-3xl font-semibold text-[#1A1A1A]">Pago cancelado</h1>
        <p className="mt-3 text-[#475569]">Puedes intentarlo cuando quieras. No se ha realizado ningún cobro.</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button onClick={() => navigate("/premium")} className="rounded-none h-11 bg-[#1A1A1A] hover:bg-[#2A2A2A] text-[#F8FAFC] px-6">
            Volver a Premium
          </Button>
        </div>
      </div>
    </div>
  );
}
